import { createFileRoute } from '@tanstack/react-router'
import { ProgressPage } from '../components/pages'
import { CatalogProvider } from '../content/catalog-context'
import { loadPageData } from '../content/page-data-fn'
import { noIndexRouteHead } from '../lib/seo'

export const Route = createFileRoute('/progress')({
  loader: () => loadPageData({ data: { kind: 'progress', locale: 'en' } }),
  head: () => noIndexRouteHead('progress', 'en'),
  component: RouteComponent,
})

function RouteComponent() {
  return (
    <CatalogProvider snapshot={Route.useLoaderData().snapshot}>
      <ProgressPage />
    </CatalogProvider>
  )
}
